import { A, Container, H1, H2, H3, Ol, P, Strong } from '#app/ui/components'

export default function LegalNotice() {
	return (
		<Container className="py-16">
			<div className="mx-auto max-w-3xl space-y-8">
				<H1>Legal Notice</H1>

				<section className="space-y-4">
					<H2>Registration Data and General Information</H2>
					<div className="space-y-2">
						<P className="mb-0">
							<Strong>Holder:</Strong> WE LOVE NIGHT S.L.
						</P>
						<P>
							<Strong>Registered Address:</Strong> Calle Miquel Marqués, 25.
							07005, Palma de Mallorca (Illes Balears), Spain
						</P>
						<P>
							<Strong>Contact:</Strong>{` `}
							<A href="mailto:bielmartinez@welovenight.com">
								bielmartinez@welovenight.com
							</A>
						</P>
						<P>
							<Strong>Registry Details:</Strong> S 8 , H PM101742, I/A 1
							(25.11.24)
						</P>
						<P>
							<Strong>TAX CODE:</Strong> B75524363
						</P>
					</div>

					<P>
						The web platform{` `}
						<A
							href="https://welovenight.com/"
							target="_blank"
							rel="noopener noreferrer"
						>
							https://welovenight.com/
						</A>{` `}
						(hereinafter, the "Platform") is owned by WE LOVE NIGHT S.L.,
						(hereinafter, "WELOVENIGHT" or the "Company"). The website has been
						created to offer detailed and updated information on the services of
						WELOVENIGHT (hereinafter, the "Contents" and / or the "Services").
					</P>

					<P>
						This legal notice (hereinafter, "Legal Notice"), together with the{` `}
						<A href="/registration-conditions">
							Registration and User Account Conditions
						</A>
						, ticket conditions for purchases (
						<A href="/purchase-conditions">Purchase Conditions</A>) privacy policy
						(hereinafter <A href="/privacy-policy">Privacy Policy</A>), and
						the cookies policy (hereinafter, "Cookies Policy") constitute the
						applicable legal framework (collectively "Legal Terms of the
						Platform") for the use of the website (hereinafter, the "Platform").
						The use of the Platform attributes to whoever uses the Platform the
						condition of user (hereinafter, "User") and implies express and full
						acceptance of the Legal Terms of the Platform. As a User, the User
						agrees to use the Platform in accordance with the Legal Terms of the
						Platform and the current legal regulations that are applicable at
						the time of use.
					</P>

					<P>
						The Legal Terms of the Platform are updated periodically, so that
						those that are in force and published at the time of use of the
						Platform will be applicable. Please read these texts carefully
						before browsing the Platform, as well as periodically. In case you
						do not agree with the Legal Terms of the Platform, please do not use
						the Platform.
					</P>
				</section>

				<Ol>
					<li className="space-y-4">
						<H2>Access and Conditions of Use</H2>
						<P>Access to the Platform is free for Users.</P>

						<P>
							Any unauthorized use is prohibited unless the User has the prior
							written permission of WELOVENIGHT. WELOVENIGHT reserves the right to
							deny, suspend, interrupt or cancel access or use, totally or
							partially, of the Platform to those Users who fail to comply with
							any of the conditions provided in this Legal Notice and/or any of
							the Legal Terms of the Platform.
						</P>

						<P>
							Therefore, WELOVENIGHT will have the right to investigate and report
							any of these behaviors in accordance with the law, as well as to
							collaborate with the authorities in the investigation of said
							actions.
						</P>

						<Ol>
							<li className="space-y-4">
								<H3>Obligation to make correct use of the Platform and Services</H3>
								<P>
									The User undertakes to make appropriate use of the Platform and the
									materials, services and forms offered through it, in accordance with
									applicable legislation and always for the purposes for which they
									have been created.
								</P>

								<P>
									To this effect, as a User, you will refrain from using the Platform
									for purposes or effects that are illicit, prohibited or
									unauthorized, or harmful to the rights and interests of third
									parties; or that in any way may damage, disable, overload,
									deteriorate or prevent the normal use of the Platform, the services,
									computer equipment, documents, files and other content offered by
									WELOVENIGHT on the Platform and/or that may be stored on any
									computer equipment of WELOVENIGHT, other users or any Internet user
									(both hardware and software).
								</P>

								<P>As a User, the User commits to (including but not limited to):</P>
								<Ol className="ml-4 space-y-2 [&>li::marker]:content-[counter(list-item,lower-alpha)')'] [&>li]:pl-2">
									<li>
										<P>
											Not to engage in illicit activities, illegal or contrary to good
											faith and public order.
										</P>
									</li>
									<li>
										<P>
											Not to cause damage to the physical and logical systems of the
											Platform, its suppliers or third parties.
										</P>
									</li>
									<li>
										<P>
											Not to introduce or spread computer viruses or any other physical
											or logical systems that may cause damage to the networks,
											equipment, systems of the Users, the Platform or WELOVENIGHT.
										</P>
									</li>
									<li>
										<P>
											Not to attempt to access, use and/or manipulate the data of
											WELOVENIGHT, third party providers and/or other users.
										</P>
									</li>
									<li>
										<P>
											Not to delete, alter, evade, or manipulate any protective device
											or security systems that may be installed in it.
										</P>
									</li>
									<li>
										<P>
											Not to use robots, data scanning and storage systems (such as
											spiders or scrapers), hidden links or any other resource, tool,
											program, algorithm or automatic data collection/extractor method
											to access, acquire, copy or monitor the Platform, without the
											express written permission of WELOVENIGHT.
										</P>
									</li>
									<li>
										<P>
											Do not use the Services and, in particular, information of any
											kind obtained through the Platform to send advertising,
											communications for direct sales purposes or with any other kind of
											commercial purpose, unsolicited messages addressed to a plurality
											of people regardless of their purpose, as well as to market or
											disclose in any way such information.
										</P>
									</li>
									<li>
										<P>
											Not to impersonate another person or organization, use
											disrespectful or offensive language such as insults, threats or
											comments that may hurt the sensibilities of other users; or
											present, recommend and / or cite companies or web portals and / or
											perform marketing or spam actions. This type of content will be
											deleted along with, where appropriate, the accounts that carried
											out such actions.
										</P>
									</li>
								</Ol>

								<P>
									WELOVENIGHT reserves the right to withdraw any content that is
									disrespectful and/or contravenes the provisions of this section, as
									well as to exercise the legal actions that are appropriate.
								</P>
							</li>

							<li className="space-y-4">
								<H3>Obligation to make correct use of the Contents</H3>
								<P>
									As a User, the User agrees to use the Contents made available to the
									User on the Platform, understanding by these, without this
									enumeration being limiting, the texts, photographs, graphics, files,
									logos, images, icons, technology, software and links; as well as the
									selection and form of presentation of the materials included in it
									and other audiovisual or sound content, its software, graphic design
									and the source codes necessary for its operation, access and use, in
									accordance with the law and the Legal Terms of the Platform; and, in
									particular, the User shall refrain from:
								</P>
								<Ol className="ml-4 space-y-2 [&>li::marker]:content-[counter(list-item,lower-alpha)')'] [&>li]:pl-2">
									<li>
										<P>
											Reproduce, copy, distribute, make available or in any other way
											publicly communicate, transform, or modify, or perform any other
											form of exploitation, by any procedure, of all or part of the
											Contents, as well as their design and the selection and form of
											presentation, unless the User has the express authorization of
											WELOVENIGHT or the owner of the corresponding rights or that such
											use is legally permitted.
										</P>
									</li>
									<li>
										<P>
											Decompile, disassemble, reverse engineer, sublicense or transmit
											in any way, translate, or make derivative works of the computer
											programs necessary for the operation, access and use of the
											Platform and the services in the contents, as well as perform,
											with respect to all or part of such programs, any of the acts of
											exploitation described in the previous paragraph. As a User of the
											Platform, the User must refrain in any case from deleting,
											altering, evading, or manipulating any protection device or
											security systems that may be installed on it.
										</P>
									</li>
									<li>
										<P>
											Delete, manipulate or in any way alter any reservation of rights
											and other identifying data.
										</P>
									</li>
								</Ol>
							</li>
						</Ol>
					</li>

					<li className="space-y-4">
						<H2>Intellectual and Industrial Property Rights</H2>
						<P>
							All Contents on the Platform, including text, photographs, graphics,
							images, icons, technology, software and other audiovisual content,
							as well as graphic design and source codes, are the property of
							WELOVENIGHT or, where appropriate, are licensed or expressly
							authorized by the owners.
						</P>

						<P>
							The information disseminated on the Platform, as well as its
							Contents, are owned by WELOVENIGHT or its authors and are considered
							protected works in accordance with the provisions of Royal Decree
							1/1996, of April 12, which approves the revised text of the
							Intellectual Property Law. In no case may it be understood that from
							WELOVENIGHT Users are transferred or authorized to exploit in any of
							its modalities the rights over said Contents beyond what is strictly
							necessary for the correct use of the Platform.
						</P>

						<P>
							The trademarks, trade names or distinctive signs of any kind that
							appear on the Platform are owned by WELOVENIGHT or have been
							published with the consent of their legitimate owners, without it
							being understood that access to the Platform attributes to Users any
							right over the aforementioned trademarks, trade names and/or
							distinctive signs.
						</P>

						<P>
							To make any kind of observation regarding possible breaches of
							intellectual or industrial property rights, as well as any of the
							Contents of the Platform, the User can contact WELOVENIGHT through
							our email{` `}
							<A href="mailto:bielmartinez@welovenight.com">
								bielmartinez@welovenight.com
							</A>{` `}
							and attach the relevant information.
						</P>

						<P>
							In any case, WELOVENIGHT does not assume any liability with respect
							to the intellectual or industrial property rights owned by third
							parties that are infringed by the Users of the Platform or by any
							other person outside WELOVENIGHT.
						</P>
					</li>

					<li className="space-y-4">
						<H2>Hyperlinks</H2>
						<P>
							The Platform may put at the User's disposal technical link devices
							(such as links, banners, buttons), which allow access to websites
							belonging to and/or managed by third parties (hereinafter, "Linked
							Sites"). The installation of these links is solely intended to
							facilitate access to the information, content, and services
							available on these Linked Sites.
						</P>

						<P>
							WELOVENIGHT does not offer or market itself or through third parties
							the information, content, and services available on the Linked
							Sites, nor does it previously control, approve, recommend, monitor
							or make them its own. WELOVENIGHT does not guarantee or assume any
							liability for damages of any kind that may be due to:
						</P>
						<Ol className="ml-4 space-y-2 [&>li::marker]:content-[counter(list-item,lower-alpha)')'] [&>li]:pl-2">
							<li>
								<P>
									The operation, availability, accessibility, or continuity of the
									Linked Sites.
								</P>
							</li>
							<li>
								<P>
									The maintenance of the information, contents, and services
									existing in the Linked Sites.
								</P>
							</li>
							<li>
								<P>
									The provision or transmission of the information, content and
									services existing on the Linked Sites.
								</P>
							</li>
							<li>
								<P>
									The quality, legality, reliability and usefulness of the
									information, contents and services existing in the Linked Sites,
									provided by third parties through the Platform.
								</P>
							</li>
						</Ol>

						<P>
							Since WELOVENIGHT has no control over the content hosted such
							channels, the User acknowledges and agrees that WELOVENIGHT assumes
							no responsibility for the content or services the User may access on
							such sites, or for any content, products, services, advertising, or
							any other material available on them. For this reason, as a User,
							the User must exercise extreme caution in the evaluation and use of
							the information, content and services existing in the linked
							channels, and about the User's own information or that of third
							parties that the User wants to share in said channels.
						</P>

						<P>
							It is expressly forbidden to introduce hyperlinks for commercial
							exploitation purposes on web pages outside WELOVENIGHT that allow
							access to this Platform without the authorization of WELOVENIGHT.
							The existence of this type of links will not imply the existence of
							commercial relations with the owner of the Platform where the
							hyperlink is established, nor the acceptance by WELOVENIGHT.
						</P>
					</li>

					<li className="space-y-4">
						<H2>Modifications</H2>
						<P>
							In order to improve the Platform, WELOVENIGHT reserves the right, at
							any time and without prior notice, to modify, extend or temporarily
							suspend the presentation, configuration, technical specifications
							and services of the Platform, unilaterally; as well as the right to
							modify at any time the Legal Terms of the Platform that, in relation
							to the Platform, have been made or may be made available to Users on
							the Platform.
						</P>
					</li>

					<li className="space-y-4">
						<H2>Exclusion of Liability</H2>
						<P>
							WELOVENIGHT does not guarantee the availability and continuity of
							the operation of the Platform, nor that it is free of errors. When
							reasonably possible, WELOVENIGHT will warn in advance of
							interruptions in the operation of the Platform. WELOVENIGHT
							excludes, to the fullest extent permitted by law, any liability for
							damages of any kind that may be due to the availability and
							continuity of access to the Platform, such as technical, security,
							control, supply interruptions, etc. As a User of the Platform, the
							User has, in any case, the obligation to have adequate tools for the
							detection and disinfection of harmful computer programs.
						</P>

						<P>
							Likewise, WELOVENIGHT excludes all liability for errors or omissions
							that may suffer from the Contents of the Platform or other content
							that can be accessed through it; as well as for any damages derived
							from the use of the Platform and/or for any action carried out on
							the basis of the information provided therein, including the
							presence of viruses or other elements that may cause alterations in
							computer systems. WELOVENIGHT will not assume responsibility of any
							kind for the use that other Users make of the Platform and/or its
							Contents, nor for the errors or omissions of third parties,
							regardless of whether these third parties may be linked to
							WELOVENIGHT through a contractual relationship.
						</P>

						<P>
							The information on the Platform is provided without warranty of any
							kind, either explicit or implied, and may be changed or updated
							without notice. WELOVENIGHT does not guarantee the absence of
							viruses, worms or other harmful computer elements that could cause
							damage or alterations to the computer system, electronic documents
							or the User's files, as a User of the Platform. Consequently,
							WELOVENIGHT excludes all liability for damages that such elements
							may cause to Users.
						</P>

						<P>
							As a User, the User will be liable for damages of any kind that
							WELOVENIGHT may suffer because of the breach of any of the
							obligations to which the User is subject by these Legal Terms of the
							Platform. As a User, the User is aware and voluntarily accepts that
							the use of any content of this Platform takes place, in any case,
							under the User's sole and exclusive responsibility, and must provide
							the necessary information in a timely manner and follow the
							guidelines and indications of the Platform.
						</P>

						<P>The Platform is not directed to Users under 18 years of age.</P>

						<P>
							In any case, WELOVENIGHT undertakes to try to solve the problems and
							/ or incidents that may arise with the greatest possible diligence
							and to offer all the necessary support to the User to, where
							appropriate, be able to reach a quick and satisfactory solution of
							the incident.
						</P>
					</li>

					<li className="space-y-4">
						<H2>Data Protection</H2>
						<P>
							In accordance with the provisions of current regulations on Data
							Protection, all personal data provided during the use of the
							Platform will be processed in accordance with the provisions of our{` `}
							<A href="/privacy-policy">Privacy Policy</A> that every user knows and
							accepts when visiting our Platform.
						</P>
					</li>

					<li className="space-y-4">
						<H2>Language</H2>
						<P>
							For WELOVENIGHT, Users are the priority, and WELOVENIGHT tries to
							address Users whenever possible in their own language. For this
							reason, WELOVENIGHT could have the Legal Terms of the Platform into
							several languages. However, in case of conflict or doubts about the
							meaning or scope of any section, term or expression contained
							therein, the English version will be given priority application, as
							it is the original version in which the Legal Terms of the Platform
							have been written.
						</P>
					</li>

					<li className="space-y-4">
						<H2>Applicable Law</H2>
						<P>
							The Legal Terms of the Platform are governed by Spanish legislation.
							The Parties submit to the Courts and Tribunals of Palma de Mallorca
							expressly waiving the forum that may correspond to them, unless the
							applicable legislation requires another jurisdiction. However, both
							parties will do everything reasonably necessary to try to resolve
							conflicts amicably.
						</P>
					</li>

					<li className="space-y-4">
						<H2>Out-of-Court Online Dispute Resolution</H2>
						<P>
							If a User has complaints or claims, the User can send them to the
							following email address:{` `}
							<A href="mailto:bielmartinez@welovenight.com">
								bielmartinez@welovenight.com
							</A>
							. In addition, if the User considers that the User's rights have
							been violated, in accordance with Regulation (EU) 524/2013 of the
							European Parliament and of the Council of May 21, 2013, WELOVENIGHT
							informs the User that the User has the right to resort to an online
							alternative dispute resolution procedure in consumer matters.
						</P>
					</li>
				</Ol>
			</div>
		</Container>
	)
}
